<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
		<div class="clearfix grid topper">
			<production-quote id="bestDirectorProdQuote2" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-md-6 col-xs-12 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="../../assets/video/best_original_screenplay_01.jpg">
					<source src="../../assets/video/best_original_screenplay_01.mp4" type='video/mp4' />
					<source src="../../assets/video/best_original_screenplay_01.webm" type='video/webm' />
				</video>
			</div>
			<production-quote id="bestDirectorProdQuote3" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote2"></production-quote>
			<div class="col-md-6 col-xs-12 col-md-pull-6 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="../../assets/video/best_original_screenplay_02.jpg">
					<source src="../../assets/video/best_original_screenplay_02.mp4" type='video/mp4' />
					<source src="../../assets/video/best_original_screenplay_02.webm" type='video/webm' />
				</video>
			</div>			
		</div>
		<div class="clearfix">
			<div class="cta-wrapper col-xs-12">
				<div class="hideme cta">
					<div class="cta-middle" v-on:click="goToUrl">CLICK HERE TO READ THE SCREENPLAY</div>
				</div>
			</div>
		</div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-original-screenplay',
	data: function() {
		return {
			heroContent: {
				"image": "best-original-screenplay-3b-lg",
				"mobileImage": "best-original-screenplay-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "BEST ORIGINAL SCREENPLAY",
				"subHeader": ['MARTIN McDONAGH'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Actress',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />One of those truly rare films that feels both profound and grounded. Martin McDonagh’s simply perfect script is never quite what you expect it to be.",
					author: '- ROGEREBERT.COM'
				},
				{
					text: "McDonagh's writing is full of verve, flair and precision.",
					author: '- LOS ANGELES TIMES'
				},
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />darkly comic drama expertly structured with a rousing narrative.",
					author: '- USA TODAY'
				},
			],
			productionQuote1: {
				text: "As we made the film, Martin was so careful to protect the beautiful sadness and the love of humanity in the film, and that’s what brings it to another level.",
				author: "Producer Graham Broadbent"
			},
			productionQuote2: {
				text: "I think Martin’s one of the great talents. His writing is so fresh, alive and funny but with such pathos and you just don’t find many screenwriters like this. He’s able to capture things about human relationships and the human condition yet he’s then able to get maximum humor, tension and emotion out of it, too.",
				author: "Woody Harrelson"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		},
		exportPDFPath: function() {
			return require('../../assets/film_scripts-3BB.pdf');
		},
		goToUrl: function() {
			window.open(this.exportPDFPath());
		}		
	}
}
</script>


// WEBPACK FOOTER //
// BestOriginalScreenplay.vue?0e8447fe